export const getBannerImageSources = (banner = {}) => {
  const desktopImage = banner?.image || banner?.image_mobile || "";

  return {
    desktopImage,
    mobileImage: banner?.image_mobile || desktopImage,
  };
};
